document.querySelectorAll('.map-link').forEach(link => {
    link.addEventListener('click', (e) => {
        // Check if map exists on current page
        if (window.officeMap) {
            e.preventDefault();
            
            const lat = parseFloat(link.dataset.lat);
            const lng = parseFloat(link.dataset.lng);
            
            // Fly to the new location
            window.officeMap.flyTo({
                center: [lng, lat],
                zoom: 13,
                speed: 3,
                essential: true
            });
            
            // Smooth scroll to map section
            const mapElement = document.getElementById('office-map');
            if (mapElement) {
                mapElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    });
});